export default function initRefreshPage() {
  const btn = document.getElementById('refresh-btn');

  if (!btn) return;

  const handleClick = (e) => {
    e.preventDefault();
    window.location.reload();
  };

  btn.addEventListener('click', handleClick);
}